import {twMerge} from "tailwind-merge";
import parser from "html-react-parser";

const TextToHTML = ({children, className}) => {
    if (!children) return <></>;
    return <div className={twMerge("ui-iransansX", className)}>{parser(children)}</div>;
};

export default TextToHTML;
